import { SET_MONSTER, TOGGLE_LOADING } from './actionType';

export const setMonster = (payload) => {
  return {
    type: SET_MONSTER,
    payload
  }
}

export const toggleLoading = () => {
  return {
    type: TOGGLE_LOADING
  }
}

export const fetchMonster = (payload) => {
  return async (dispatch, getState) => {
    dispatch(toggleLoading())
    try {
      const res = await fetch(`https://db.ygoprodeck.com/api/v7/cardinfo.php/?id=${payload}`)
      if (res.ok) {
        const result = await res.json()
        dispatch(setMonster(result.data[0]))
      } else {
        if (res.status === 400) {
          throw Error('Card not found')
        }
        throw Error('Something went wrong')
      }
    } catch (err) {
      return err
    } finally {
      dispatch(toggleLoading())
    }
  }
}